import React from "react";
import { SURGEON_ROLES, useAuth, useQueryParams } from "duck";
import { useAnestheticProtocolsQuery } from "requests";
import { getFilterData } from "./utils";

export const useAnestheticProtocols = () => {
  const [{ filter, search }] = useQueryParams();
  const [params, setParams] = useQueryParams();
  const [{ user }] = useAuth();
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    if (SURGEON_ROLES.includes(user.userRole)) {
      setParams({
        ...params,
        filter: { ...params.filter, doctors: [user._id] }
      });
    }
    setReady(true);
  }, [user]);

  const { data, loading } = useAnestheticProtocolsQuery({
    variables: {
      search,
      filter: {
        equal: {
          defaultProtocol: false
        },
        ...getFilterData(filter, search)
      }
    },
    fetchPolicy: "cache-and-network",
    skip: !ready
  });

  const defaultAnestheticProtocols = data?.defaultProtocols?.collection || [];
  const anestheticProtocols = data?.anestheticProtocols?.collection || [];
  return {
    anestheticProtocols: [
      ...defaultAnestheticProtocols,
      ...anestheticProtocols
    ],
    loading
  };
};
